export default "__VITE_ASSET__L8Honkl9__"